import styles from './../../assets/styles/Admin/AdminProducts.module.scss';
import MimaButton from '../Button/MimaButton';
import emptyStateIcon from '../../assets/img/empty-state.png';

export const EmptyState = ({
	text = 'No data found',
	subText,
	className,
	buttonTitle,
	onButtonClick,
}) => {
	return (
		<div className={`${styles.emptyState} ${className || ''}`}>
			<img
				src={emptyStateIcon}
				alt="empty"
				className={styles.emptyState__icon}
			/>
			<h3 className={styles.emptyState__title}>{text}</h3>
			{subText && <p className={styles.emptyState__subText}>{subText}</p>}
			{buttonTitle && onButtonClick && (
				<div className={styles.emptyState__action}>
					<MimaButton
						title={buttonTitle}
						onClick={onButtonClick}
						variant="contained"
					/>
				</div>
			)}
		</div>
	);
};

export default EmptyState;
